import axios, { CancelToken } from 'axios';
import { navigate } from 'gatsby';
import GoogleTagManager from '../helpers/GoogleTagManager';
import redirect from '../helpers/RedirectToExternalPage';
import { logoutUser } from '../helpers/Auth';
import { getUrl } from './requestHelper';

const authRequest = requests => {
  const timeout = 30000;
  const source = CancelToken.source();
  const r = requests.map(req => {
    const axiosConfig = {
      baseURL: getUrl(req.url),
      method: req.method,
      cancelToken: source.token,
    };
    if (req.data) {
      axiosConfig.data = req.data;
    }
    return axios(axiosConfig);
  });
  const onSuccess = axios.spread((...responses) => {
    return responses.map(resp => resp.data);
  });
  const onError = error => {
    if (error.response) {
      const { data } = error.response;
      const { code } = data;
      if (code === 'expired_code') {
        GoogleTagManager.tagInteractiveEvent({
          eventCategory: 'Token Vencido - MiWOM',
          eventAction: 'Usuario con Token Vencido',
          eventTag: 'Usuario Token Vencido',
        });
        logoutUser();
        redirect(`${process.env.SSO_URL}sesion-expirado?&channel=movil`);
      }
      if (
        code === 'missing_auth_token' ||
        code === 'expired_code' ||
        code === 'invalid_data'
      ) {
        navigate('/');
      }
    }

    return Promise.reject(error.response || error);
  };
  const onEnd = response => {
    return response;
  };
  setTimeout(() => {
    source.cancel();
  }, timeout);
  return axios
    .all(r)
    .then(onSuccess)
    .catch(onError)
    .then(onEnd);
};
export default authRequest;
